import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=c48f4d88&"
import script from "./culture.vue?vue&type=script&lang=js&"
export * from "./culture.vue?vue&type=script&lang=js&"
import style0 from "./culture.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports